export { default } from './ConfirmPayoutCustomerApprove';



// WEBPACK FOOTER //
// ./src/lauoyts/Common/Confirm/ConfirmPayoutCustomerApprove/index.js